import React from 'react';
import { Users, Utensils, Sparkles, TrendingUp, Coffee, DollarSign } from 'lucide-react';

const iconMap = {
  Users,
  Utensils,
  Sparkles,
  TrendingUp,
  Coffee,
  DollarSign
};

const Experience = ({ experiences }) => {
  return (
    <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2
            className="text-4xl md:text-5xl font-bold text-gray-900 mb-4"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            La Experiencia Pomodoro
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Esto es lo que nuestros clientes valoran de nosotros
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {experiences.map((exp, index) => {
            const IconComponent = iconMap[exp.icon];
            return (
              <div
                key={index}
                className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-100"
              >
                <div className="w-16 h-16 bg-[#C1272D]/10 rounded-full flex items-center justify-center mb-6">
                  <IconComponent className="text-[#C1272D]" size={32} />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {exp.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {exp.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Experience;
